import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const drawerFooterVariants = cva(
    'rocco-drawer-footer flex flex-col-reverse gap-2 sm:flex-row sm:justify-end',
    {
        variants: {
            variant: {
                default:
                    'border-t border-gray-900/30 px-6 py-5.5 md:pb-5 md:pt-4',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export const DrawerFooter = ({
    className,
    variant,
    ...props
}: React.HTMLAttributes<HTMLDivElement> &
    VariantProps<typeof drawerFooterVariants>) => (
    <div
        data-slot="drawer-footer"
        className={cn(drawerFooterVariants({ variant, className }))}
        {...props}
    />
);

DrawerFooter.displayName = 'DrawerFooter';
